import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'm-folder-tree-icon',
  templateUrl: 'folder-tree-icon.component.html'
})
export class FolderTreeIconComponent {
  constructor() {}
}
